import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { ImbpSmartMeterOfferedSlot } from "./imbpSmartMeterOfferedSlot"
import { IImbpSmartMeterOfferedSlot } from "./imbpSmartMeterOfferedSlot.types"
import { OfferedAppointment } from "@/api/backofficeRest/generated/model"

export type IImbpSmartMeterOfferedSlotRaw = OfferedAppointment

export const ImbpSmartMeterOfferedSlotParser: IParser<
  IImbpSmartMeterOfferedSlot,
  IImbpSmartMeterOfferedSlotRaw
> = {
  toDomain: (data: IImbpSmartMeterOfferedSlotRaw) => {
    try {
      return new ImbpSmartMeterOfferedSlot(
        data.appointmentStart ?? "",
        data.appointmentEnd ?? "",
        data.dateOffered ?? "",
        data.channel ?? "",
        data.installer ?? null,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
